<template>
	<app-header-teleport>
		<app-title :title="`${$t('my_businesses')}`" />
	</app-header-teleport>
	<app-section>
		<business-table
			:restaurants="user.restaurants"
			@open-menu="openMenu"
			@open-toppings="openToppings"
			@open-top-products="openTopProducts"
			@statusUpdate="getRestaurants"
			@openExtraDeliveryTimeModal="showExtraDeliveryTimeModal"
		/>
	</app-section>
	<extra-delivery-time-modal
		v-if="showDelayModal && canEditExtraDeliveryTime"
		:business="business"
		@close="showDelayModal = false"
	/>
</template>

<script>
	import { mapGetters } from 'vuex';
	import BusinessTable from '@/components/sales/BusinessTable';
	import RouteNames from '@/router/names';
	import ExtraDeliveryTimeModal from '@/components/ExtraDeliveryTimeModal.vue';
	import BusinessService from '@/services/sales/BusinessService';

	export default {
		name: 'MyBusinesses',
		components: {
			ExtraDeliveryTimeModal,
			BusinessTable,
		},
		computed: {
			...mapGetters({
				user: 'user',
			}),
			canEditExtraDeliveryTime() {
				return BusinessService.canEditExtraDeliveryTime();
			},
		},
		data: () => ({
			showDelayModal: false,
			business: {},
		}),
		methods: {
			showExtraDeliveryTimeModal(item) {
				this.showDelayModal = true;
				this.business = item;
			},
			openMenu(business) {
				this.$router.push({
					name: RouteNames.BusinessMenu,
					params: { id: business.restaurantID },
					query: { n: business.restaurantName },
				});
			},
			openToppings(business) {
				this.$router.push({
					name: RouteNames.ToppingsList,
					params: { id: business.restaurantID },
					query: { n: business.restaurantName },
				});
			},
			openTopProducts(business) {
				this.$router.push({
					name: RouteNames.TopProducts,
					params: { id: business.restaurantID },
					query: { n: business.restaurantName },
				});
			},
			getRestaurants() {},
		},
	};
</script>
